
import React, { Component } from "react"
import { Link } from "react-router-dom"
import MetaTags from 'react-meta-tags';

import {
  Col, Alert, Container, Row, Label,
} from "reactstrap"

// import images
import logodark from "../../assets/images/kattam-login.png"
import CarouselRegisterPage from "./CarouselRegisterPage"

// availity-reactstrap-validation
import { AvField, AvForm, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
// action
import { apiError, registerUser, registerUserFailed } from "../../store/actions"
import { onGetCaptcha } from "store/actions"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { countries } from "../../common/data/country"
import { isEmpty, isEqual } from "lodash"
import PageLoader from "pages/Common/PageLoader";

class Register extends Component {
  constructor(props) {
    super(props)
    this.state = {
      passCountryErrorField: '',
      passCountryErrorElement: false,
      passCodeErrorField: '',
      passCodeErrorElement: false,
      country: 'India',
      countryCode: '+91',
      loading: false,
      aadharNumber: '',
      passportNumber: '',
      captchaOject: {}
    }

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
    this.goToLogin = this.goToLogin.bind(this)
    this.phoneChange = this.phoneChange.bind(this)
    this.handleCountry = this.handleCountry.bind(this)
  }

  goToLogin() {
    this.props.history.push("/login")
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    values.country = this.state.country
    values.dailingCode = this.state.countryCode
    values.captchaToken = this.state.captchaOject.captchaToken
    console.log("Inside handleValidSubmit ::::::::::")
    this.props.registerUser(values, this.props.history)
  }

  handleCountry(event) {
    let country = JSON.parse(event.target.value);
    if (country == "-1") {
      this.setState({
        country: '',
        countryCode: ''  })
      return;
    }
    this.setState({
      country: country.name,
      countryCode: country.pcode
    })
  }
  
  componentDidMount() {
    this.props.apiError("")
    this.props.registerUserFailed("")
    this.props.onGetCaptcha()
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("componentDidUpdate->called")
    const { captchaOject, actionResult } = this.props
    if (!isEmpty(captchaOject) && !isEqual(prevProps.captchaOject, captchaOject)) {
      this.setState({ captchaOject })
      console.log("componentDidUpdate->captchaOject, ", captchaOject)
    }
  }

  phoneChange(e) {
    const re = /^[0-9\b]+$/;
    console.log("Inside phoneChange :::::::::::::::")
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ phone: e.target.value })
    }
  }

  renderLoader = () => {
    console.log("loader->true")
    if (this.state.loading === true)
      return <PageLoader loaderMsg="Generating report... please wait..." />
    return null
  }

  renderError() {
    if (!isEmpty(this.props.error)) {
      if (isEqual(this.props.error, "Bad credentials")) {
        return <Alert color="danger">Invalid username or password</Alert>
      } else if (isEqual(this.props.error, "Invalid Captcha")) {
        return <Alert color="danger">Invalid captcha</Alert>
      } else {
        return <Alert color="danger">{this.props.error}</Alert>
      }
    } else
      return null;
  }

  render() {
    const { captchaOject } = this.state
    const imageSrc = "data:image/png;base64," + captchaOject.captchaImage;
    const { registrationError } = this.props
    let registrationErrorMessage;
    if (!isEmpty(registrationError)) {
      try {
        if (typeof registrationError === "object") {
          registrationErrorMessage = "Try registering some other time or contact administrator"
        } else if (typeof registrationError === "string") {
          registrationErrorMessage = registrationError
        }
      } catch (error) {
        registrationErrorMessage = "Try registering some other time or contact administrator"
      }
    }
    const model = {
      licensecheckbox: true
    };
    return (
      <React.Fragment>
        <div>
          <MetaTags>
            <title>Register | Kattam</title>
          </MetaTags>
          <Container fluid className="p-0">
            <Row className="g-0">
              <CarouselRegisterPage />
              {this.props.loading && this.props.loading ? (
                <PageLoader loaderMsg="Registering your profile... please wait..." />
              ) : null}

              <Col xl={7}>
                <div className="auth-full-page-content p-md-4 p-2">
                  <div className="w-100">
                    <div className="d-flex flex-column h-100">
                      <div className="mb-4 mb-md-2">
                        <img
                          src={logodark}
                          alt=""
                          height="80"
                          className="auth-logo-dark" />
                      </div>
                      <div className="my-auto mt-4" >
                        <div>
                          <h5 className="text-primary">Create your Kattam Account</h5>
                        </div>

                        <div className="mt-4">
                          <AvForm
                            className="needs-validation"
                            onValidSubmit={this.handleValidSubmit}
                            model={model}
                          >
                            {this.props.user && this.props.user ? (
                              <Alert color="success">
                                Register user successfull
                              </Alert>
                            ) : null}
                            {registrationErrorMessage && (
                              <Alert color="danger">
                                {registrationErrorMessage}
                              </Alert>
                            )}

                            <Alert color="info" className="mb-0" role="alert">
                              <h5 className="font-size-16 me-3">Personal details</h5>
                            </Alert>
                            <br />

                            <Row>
                              <Col>
                                <div className="mb-3">
                                <Label>
                                  First name <span style={{ color: 'red' }}>*</span>
                                </Label>
                                  <AvField
                                    name="firstName"
                                    className="form-control"
                                    placeholder="First name"
                                    type="text"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a first name' },
                                      // pattern: { value: '^[a-zA-Z]+(([,. -][a-zA-Z ])?[a-zA-Z]*)*$', errorMessage: 'First name can only contain aphanumeric and space' },
                                      pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ]*)?$', errorMessage: 'First name can only contain aphanumeric and space' },
                                      minLength: { value: 3, errorMessage: 'First name must have minimum 3 characters.' },
                                      maxLength: { value: 30, errorMessage: 'First name must not be greater than 30 characters.' }
                                    }}
                                  />
                                </div>
                              </Col>

                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="lastName"
                                    label="Last name"
                                    className="form-control"
                                    placeholder="Last name"
                                    type="text"
                                    validate={{
                                      //pattern: { value: '^[a-zA-Z]+(([,. -][a-zA-Z ])?[a-zA-Z]*)*$', errorMessage: 'Last name can only contain aphanumeric and space' },
                                      pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 ]*)?$', errorMessage: 'First name can only contain aphanumeric and space' },
                                      maxLength: { value: 30, errorMessage: 'Last name must not be greater than 30 characters.' }
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <Row>

                                  <Col>
                                    <div className="mb-3">
                                      <Label>
                                      Address <span style={{ color: 'red' }}>*</span>
                                    </Label>
                                      <AvField
                                        name="address1"
                                        type="text"
                                        placeholder="Door No., Floor"
                                        validate={{
                                          required: { value: true, errorMessage: 'Please enter a address' },
                                          minLength: { value: 10, errorMessage: 'Address must have minimum 10 characters.' },
                                        }}
                                      />
                                    </div>
                                  </Col>
                                  <Col>
                                    <div className="mb-3">
                                    <Label>
                                    Address 
                                    </Label>
                                      <AvField
                                        name="address2"
                                        type="text"
                                        placeholder="Street Name, Area"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <div className="mb-3">
                                  <Label>
                                  City <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField
                                    name="city"
                                    type="text"
                                    placeholder="City"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a city' }
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col>
                                <div className="mb-3">
                                 <Label>
                                 State <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField
                                    name="state"
                                    type="text"
                                    placeholder="State"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a state' }
                                    }}

                                  />
                                </div>
                              </Col>

                            </Row>

                            <Row>
                              <Col className="col-md-6">
                                <div className="mb-3">
                                <Label>
                                 Country <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField type="select" name="country" onChange={this.handleCountry}
                                  >
                                    <option value="-1">Select Country</option>
                                    {countries.map((country, index) => (
                                      <option value={JSON.stringify(country)} key={index}>{country.name}</option>
                                    ))}
                                  </AvField>
                                </div>
                              </Col>

                              <Col>
                                <Row>
                                <Label>
                                 Mobile <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <Col md="4" className="pe-md-0 md-pe-3">
                                    <AvField type="text" name="mobilecode" placeholder="Code" value={this.state.countryCode}
                                      disabled
                                      validate={{
                                        required: { value: true, errorMessage: 'Please select a country code' }
                                      }}
                                    >
                                    </AvField>
                                  </Col>
                                  <Col md="" className="ps-md-0">
                                    <AvField
                                      name="mobile"
                                      type="text"
                                      placeholder="Mobile"
                                      validate={{
                                        required: { value: true, errorMessage: 'Please enter mobile.' },
                                        pattern: { value: '^[0-9]{8,11}$', errorMessage: 'Please enter a valid mobile.' }
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="aadharNumber"
                                    label="Aadhar Number"
                                    type="text"
                                    placeholder="Aadhar Number"
                                    maxLength="12"
                                    validate={{
                                      pattern: { value: '^[0-9]{12}$', errorMessage: 'Please enter a valid 12 digit aadhar number' }
                                    }}

                                  />
                                </div>
                              </Col>
                              <Col>
                                <div className="mb-3">
                                  <AvField
                                    name="passportNumber"
                                    label="Passport Number"
                                    type="text"
                                    placeholder="Passport Number"
                                    maxLength="9"
                                    validate={{
                                      pattern: { value: '^[a-zA-Z0-9]{3,9}$', errorMessage: 'Please enter a valid passport number' }
                                    }}
                                  />
                                </div>
                              </Col>

                            </Row>

                            <Row className="col-md-6">
                              <Col>
                                <div className="mb-3">
                                <Label>
                                 Email <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField
                                    name="email"
                                    className="form-control"
                                    placeholder="Email"
                                    errorMessage="Please enter a vaild email"
                                    type="email"
                                    required
                                  />
                                </div>
                              </Col>
                            </Row>

                            {/* <span className="text-success">
                              Login details
                            </span> */}

                            <Alert color="info" className="mb-0" role="alert">
                              <h5 className="font-size-16 me-3">Login details</h5>
                            </Alert>
                            <br />

                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                <Label>
                                Username <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField
                                    name="username"
                                    type="text"
                                    placeholder="Username"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a username' },
                                      /*pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9 @&$_-]*)?$', errorMessage: 'Username can contain aphanumeric, space and @&$_-' },*/
                                      pattern: { value: '^(?!\d+$)(?:[a-zA-Z0-9][a-zA-Z0-9@&$_-]*)?$', errorMessage: 'Username cannot contain space' },
                                      minLength: { value: 6, errorMessage: 'Username must have minimum 6 characters.' },
                                      maxLength: { value: 30, errorMessage: 'Username must not be greater than 30 characters.' },
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col>
                                <div className="mb-3">
                                <Label>
                                Password <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField
                                    name="password"
                                    type="password"
                                    placeholder="Password"
                                    errorMessage="Enter password"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please enter a password.' },
                                      minLength: { value: 6, errorMessage: 'Password must have minimum 6 characters.' },
                                      maxLength: { value: 30, errorMessage: 'Password must not be greater than 30 characters.' }
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col>
                                <div className="mb-3 ">
                                <Label>
                                Confirm password <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                  <AvField
                                    name="confirmPassword"
                                    type="password"
                                    placeholder="Confirm password"
                                    validate={{
                                      required: { value: true, errorMessage: 'Please confirm your password.' },
                                      match: { value: 'password', errorMessage: 'Password and confirm password must be same.' }
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <div className="lead mb-3">
                                <AvCheckboxGroup name="licensecheckbox" >
                                  <AvCheckbox label="By creating an account, you are agreeing to our Terms of Service and Privacy Policy." checked disabled />
                                </AvCheckboxGroup>
                              </div>
                            </Row>
                            <Row>
                              <div className="mb-3">
                                  <Label>
                                  Captcha <span style={{ color: 'red' }}>*</span>
                                  </Label>
                                <AvField
                                  name="userCaptcha"
                                  type="text"
                                  required
                                  placeholder="Enter Captcha"
                                  errorMessage="Please enter your Captcha"
                                />
                              </div>
                            </Row>
                            <Row>
                              <div className="mb-3">
                                <img id="ItemPreview" src={imageSrc} />
                              </div>
                            </Row>


                            <div className="mt-4 d-grid">
                              <button
                                className="btn btn-primary btn-block waves-effect waves-light"
                                type="submit"
                              >
                                Register
                              </button>
                            </div>
                          </AvForm>
                          <div className="mt-3 text-center">
                            <p>
                              Already have an account ?{" "}
                              <Link
                                to="login"
                                className="fw-medium text-primary"
                              >
                                {" "}
                                Login
                              </Link>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4 mt-md-5 text-center">
                        <p className="mb-0">
                        Copyright © {new Date().getFullYear()} Kattam Intelligence Pte. Ltd. All rights reserved.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment >
    )
  }
}

Register.propTypes = {
  apiError: PropTypes.any,
  registerUser: PropTypes.func,
  registerUserFailed: PropTypes.any,
  registrationError: PropTypes.any,
  user: PropTypes.object,
  history: PropTypes.object,
  onGetCaptcha: PropTypes.func
}

const mapStateToProps = state => {
  const { user, registrationError, loading } = state.Account
  const { captchaOject } = state.Login
  return { user, registrationError, loading, captchaOject }
}

export default connect(mapStateToProps, {
  registerUser,
  apiError,
  registerUserFailed,
  onGetCaptcha,
})(Register)